// extracted by mini-css-extract-plugin
export default {"collect":"index_collect_ft1Ou","collectIcon":"index_collectIcon_hh3OJ","success":"index_success_NIxyw"};